export default __webpack_public_path__ + "static/media/draft_line_icon.a78be71a.svg";